module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " kuni ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " valitud");
  },
  "finishRangeSelectionPrompt": "Kl\xF5psake kuup\xE4evavahemiku valimise l\xF5petamiseks",
  "maximumDate": "Viimane saadaolev kuup\xE4ev",
  "minimumDate": "Esimene saadaolev kuup\xE4ev",
  "next": "J\xE4rgmine",
  "previous": "Eelmine",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Valitud kuup\xE4ev: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Valitud vahemik: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Kl\xF5psake kuup\xE4evavahemiku valimiseks",
  "todayDate": function todayDate(args) {
    return "T\xE4na, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "T\xE4na, ".concat(args.date, " valitud");
  }
};